import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { initAlertEngine } from './lib/alert-engine';
import { openDB } from './lib/db';

const SpectrumPage = lazy(() => import('./pages/SpectrumPage'));
const AlertsPage = lazy(() => import('./pages/AlertsPage'));
const DevicesPage = lazy(() => import('./pages/DevicesPage'));
const BaselinePage = lazy(() => import('./pages/BaselinePage'));
const ConnectPage = lazy(() => import('./pages/ConnectPage'));

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <div className="w-6 h-6 border-2 border-scope-trace/30 border-t-scope-trace rounded-full animate-spin mx-auto" />
        <p className="text-xs text-gray-600 readout mt-2">Loading</p>
      </div>
    </div>
  );
}

function Page({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}

export default function App() {
  useEffect(() => {
    openDB().catch(() => {});
    const cleanup = initAlertEngine();
    return cleanup;
  }, []);

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Page><SpectrumPage /></Page>} />
        <Route path="alerts" element={<Page><AlertsPage /></Page>} />
        <Route path="devices" element={<Page><DevicesPage /></Page>} />
        <Route path="baseline" element={<Page><BaselinePage /></Page>} />
        <Route path="connect" element={<Page><ConnectPage /></Page>} />
        <Route path="*" element={<Page><SpectrumPage /></Page>} />
      </Route>
    </Routes>
  );
}
